import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead, SITE_URL } from "@/components/SEO";
import { buildFaqJsonLd } from "@/components/FAQSection";
import { FAQS } from "@/data/faqs";

export const Route = createFileRoute("/about")({
  head: () =>
    buildHead({
      path: "/about",
      jsonLd: buildFaqJsonLd(FAQS["/about"].items),
      breadcrumbs: [
        { name: "Home", url: SITE_URL },
        { name: "About GoHub", url: `${SITE_URL}/about` },
      ],
    }),
  component: lazyRouteComponent(() => import("@/pages/About")),
});
